import React from "react";
import { useEffect, useState } from "react";
import { Bar} from "react-chartjs-2";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import { Grid, Hidden } from "@material-ui/core";
import { appStyles } from "../../../app/app-style";
import moment from "moment";
import { store } from "../../../../helpers/store";
import getBillComparison from "../model/e_bill_comparison_service";
import { Typography } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import {useTranslation} from 'react-i18next';
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  mainGrid : {
    height: "100%",
    flexFlow: "row"
  },
  chartDiv : {
    height: "95%",
    maxWidth: "100px"
  },
  thisBill:{
    color : theme.palette.eSecondary?.base,
  },
  previousBillColor:{
    color:theme.palette.ePastelColor2?.base
  }

}))


export default function BillComparisonChart({BillData,previousBillAmount,currentBillAmount}){
    const billClasses = useStyle();
    const {t:billComparisonLabels, ready: labelReady} = useTranslation("label-E_BILL_COMPARISON")
     let thisBill = appStyles.outerTheme.palette.eSecondary?.base;
     let previousBill = appStyles.outerTheme.palette.ePastelColor2?.base;
     let dateFormat = useSelector((state)=>state?.parametersWidgets?.ParameterLookup?.SHORT_DATE_FORMAT)
    const chartOptions = ({ 
      responsive: true,
      maintainAspectRatio: false,
      plugins:{
        legend: {
          display:false,
        },
          tooltip: false,
      },
      indexAxis: 'x',
        scales: {
          x: 
            {
              
              barPercentage: 0.8,
              categoryPercentage :0.5,
              ticks: {
                  display:false,
              },
              display:false,
              grid: {
                display: false,
              },
            },
          
          y: 
            {
              barPercentage: 0.8,
              categoryPercentage :0.5,
              beginAtZero : true,
              display:false,
              grid: {
                display: false,
              },
              ticks: {
                display:false,
                beginAtZero: true,
              },
            },
          
        },
    });
    const data ={
      labels:[labelReady ? (billComparisonLabels("E_THIS_BILL"),billComparisonLabels("E_THIS_BILL")) : "", ""],
        datasets: [
            { 
              label:labelReady ? billComparisonLabels("E_THIS_BILL") : "",
              data: [currentBillAmount],
              fill: true,
              backgroundColor: thisBill,
            },
            { 
              data: [0],
              fill: false,
            },
            {
              label:labelReady ? billComparisonLabels("E_PREVIOUS_BILL") : "", 
              data: [previousBillAmount],
              fill: true,
              backgroundColor: previousBill,
            },
          ]
    }
    const isTabletOrMobile = useMediaQuery({ minWidth: 900 });
  const isDesktop = useMediaQuery({ minWidth: 1280 });
  const isMobile = useMediaQuery({ minWidth: 300 });
    return(
      <>
        <Grid container justify='center' className={billClasses.mainGrid}>
          <Grid container direction="column" align='right' justify="center" alignItems="center" >
              {
                labelReady ? 
                <>
              <Typography variant="caption">{billComparisonLabels("E_THIS_BILL")}</Typography>
              <Typography variant="subtitle1" className={billClasses.thisBill}><b>{billComparisonLabels("E_CURRENCY")}{currentBillAmount}</b></Typography>
              <Typography variant="caption" >{`${moment(BillData?.[0]?.billDate).format(dateFormat)}`}</Typography><br/>
              <Typography variant="caption" >{moment(BillData?.[0]?.billDate).daysInMonth()} {billComparisonLabels("E_DAYS")}</Typography>
              </>
              : <Skeleton />
              }
          </Grid>
        
          <Grid item>
            <div className={billClasses.chartDiv}>
              <Bar align='center' justify='center'
                options={chartOptions}
                data ={data}/>
            </div>
          </Grid>
        
        <Grid container direction="column" align='left' justify="center">
        {
          labelReady ?
          <>
          <Typography variant="caption">{billComparisonLabels("E_PREVIOUS_BILL")}</Typography>
          <Typography variant="subtitle1" className={billClasses.previousBillColor}><b>{billComparisonLabels("E_CURRENCY")}{previousBillAmount}</b></Typography>
          <Typography variant="caption">{`${moment(BillData?.[1]?.billDate).format(dateFormat)}`}</Typography><br/>
          <Typography variant="caption">{moment(BillData?.[1]?.billDate).daysInMonth()} {billComparisonLabels("E_DAYS")}</Typography>
          </>
          : <Skeleton />
        }
        </Grid> 
        </Grid>
        </>
    );
}